import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../lib/api";
import { useAuth } from "../lib/auth";
import { useI18n } from "../lib/i18n";
import { AuthShell, Field, SubmitBtn } from "../components/AuthShell";

export default function Register() {
  const { t, lang } = useI18n();
  const { setSession } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ first_name: "", last_name: "", email: "", password: "" });
  const [accept, setAccept] = useState(false);
  const [loading, setLoading] = useState(false);

  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!accept) {
      toast.error("Morate prihvatiti uslove korišćenja.");
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", { ...form, accept_terms: accept, lang });
      setSession(data.token, data.user);
      toast.success(data.message || "Nalog je kreiran.");
      navigate("/");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title={t("register_title")} subtitle={t("auth_cta_sub")}>
      <form onSubmit={submit}>
        <div className="grid grid-cols-2 gap-3">
          <Field label={t("first_name")} testid="register-firstname" required value={form.first_name} onChange={upd("first_name")} />
          <Field label={t("last_name")} testid="register-lastname" required value={form.last_name} onChange={upd("last_name")} />
        </div>
        <Field label={t("email")} testid="register-email" type="email" required value={form.email} onChange={upd("email")} />
        <Field label={t("password")} testid="register-password" type="password" required value={form.password} onChange={upd("password")} />
        <label className="flex items-start gap-3 mb-6 cursor-pointer">
          <input
            type="checkbox"
            data-testid="register-accept"
            checked={accept}
            onChange={(e) => setAccept(e.target.checked)}
            className="mt-1 accent-nhgreen w-4 h-4"
          />
          <span className="font-mono text-xs text-white/60 leading-relaxed">{t("accept_terms")}</span>
        </label>
        <SubmitBtn loading={loading} testid="register-submit">{t("submit_register")}</SubmitBtn>
      </form>
      <p className="font-mono text-xs text-white/50 mt-6 text-center">
        {t("have_account")}{" "}
        <Link to="/login" data-testid="register-to-login" className="text-nhgreen hover:underline">
          {t("nav_login")}
        </Link>
      </p>
    </AuthShell>
  );
}
